import gql from "graphql-tag"

// Plain field lists, never fragments `on Me`: the API forwards selections to
// Prisma, which has no Me type (see components/onboarding/queries.js).
const LOOKUP = `{
      id
      itemId
      label
    }`

const PROFILE_FIELDS = `
    id
    firstName
    location
    locationCountry
    locationLat
    locationLng
    locationTimezone
    createdAt
    profilePic
    headline
    coverStyle
    coverPhoto
    profileLinksJson
    profilePromptsJson
    whyMakeGoodCofounder
    elevatorPitchForStartup
    hasIdeaForStartup
    lookingToJoinStartupAsFounder
    hasOwnStartup
    interestedInJobsForStartups
    ownStartupUrl
    hasValidCoFounderSubscription
    hasSkills ${LOOKUP}
    wantsSkills ${LOOKUP}
    hoursPerWeekAvailable ${LOOKUP}
    ideaStage ${LOOKUP}
    ideaIndustry ${LOOKUP}
    startupStage ${LOOKUP}
    startupIndustry ${LOOKUP}
`

export const PROFILE_PAGE_QUERY = gql`
  query PROFILE_PAGE_QUERY($id: ID, $loggedInUserId: ID) {
    user(where: { id: $id }) {
      ${PROFILE_FIELDS}
      ideas {
        id
        title
        elevatorPitch
        isActive
        createdAt
        totalLikes
        totalComments
        ideaStage ${LOOKUP}
        ideaIndustry ${LOOKUP}
      }
      nestAnswers {
        id
        body
        questionTitle
        questionSlug
      }
      addedBy(where: { id: $loggedInUserId }) {
        id
      }
    }
  }
`

export const SIMILAR_FOUNDERS_QUERY = gql`
  query SIMILAR_FOUNDERS_QUERY($id: ID!) {
    similarFounders(userId: $id, first: 3) {
      skillItemId
      intent
      founders {
        id
        firstName
        profilePic
        location
        hasSkills ${LOOKUP}
      }
    }
  }
`

// What the profile mutations read back into the cached `me`. Same
// sub-selections as CURRENT_USER_QUERY (components/me/me.js); `ideas` is left
// out, the idea editors refetch `me` instead.
export const PROFILE_ME_FIELDS = `
    id
    email
    firstName
    lastName
    location
    locationCountry
    locationLat
    locationLng
    locationTimezone
    profilePic
    headline
    coverStyle
    coverPhoto
    profileLinksJson
    profilePromptsJson
    whyMakeGoodCofounder
    elevatorPitchForStartup
    hasIdeaForStartup
    lookingToJoinStartupAsFounder
    hasOwnStartup
    interestedInJobsForStartups
    ownStartupUrl
    lastEdited
    hasSkills ${LOOKUP}
    wantsSkills ${LOOKUP}
    hoursPerWeekAvailable ${LOOKUP}
    startupStage ${LOOKUP}
    startupIndustry ${LOOKUP}
`

export const UPDATE_PROFILE_SECTION = gql`
  mutation UPDATE_PROFILE_SECTION($section: String!, $input: ProfileSectionInput) {
    updateProfileSection(section: $section, input: $input) {
      ${PROFILE_ME_FIELDS}
    }
  }
`

export const UPLOAD_COVER_PHOTO = gql`
  mutation UPLOAD_COVER_PHOTO($dataUrl: String!, $crop: PhotoCropInput) {
    uploadCoverPhoto(dataUrl: $dataUrl, crop: $crop) {
      id
      coverStyle
      coverPhoto
    }
  }
`

export const UPLOAD_PROFILE_PHOTO = gql`
  mutation UPLOAD_PROFILE_PHOTO($dataUrl: String!, $crop: PhotoCropInput) {
    uploadProfilePhoto(dataUrl: $dataUrl, crop: $crop) {
      id
      profilePic
    }
  }
`

export const SAVE_FOUNDER = gql`
  mutation SAVE_FOUNDER($userId: ID!, $loggedInUserId: ID!) {
    addUser(userId: $userId) {
      id
      addedBy(where: { id: $loggedInUserId }) {
        id
      }
    }
  }
`

export const REPORT_USER = gql`
  mutation REPORT_USER($userId: ID!) {
    reportUser(userId: $userId, reportedFrom: "PROFILE") {
      success
    }
  }
`

export const CREATE_IDEA = gql`
  mutation CREATE_IDEA($title: String!, $elevatorPitch: String!, $ideaStage: Int!, $ideaIndustry: Int!) {
    addIdea(title: $title, elevatorPitch: $elevatorPitch, ideaStage: $ideaStage, ideaIndustry: $ideaIndustry) {
      id
    }
  }
`

export const UPDATE_IDEA = gql`
  mutation UPDATE_IDEA(
    $id: ID!
    $title: String
    $elevatorPitch: String
    $ideaStage: Int
    $ideaIndustry: Int
    $isActive: Boolean
  ) {
    updateIdea(
      id: $id
      title: $title
      elevatorPitch: $elevatorPitch
      ideaStage: $ideaStage
      ideaIndustry: $ideaIndustry
      isActive: $isActive
    ) {
      success
    }
  }
`
